<template>
  <!-- -->

  <Modal
    v-model="liveTop"
    width="500px"
    class-name="vertical-center-modal"
    @on-cancel="cancel"
  >
    <div style="min-height: 300px; padding: 40px 60px">
      <div class="zhuce">重置密码</div>

      <Form ref="formItem" :model="formItem" :rules="ruleInfo" :label-width="0">
        <div v-if="comlist == 0">
          <FormItem class="liItem">
            <img style="width: 22px; height: 25px" src="@/assets/image/inpone.png" />
            <Input height="50px" v-model="formItem.mobile" placeholder="请输入您的手机号">
            </Input>
          </FormItem>
          <FormItem class="liItem top_input">
            <img style="width: 23px; height: 25px" src="@/assets/image/dui.png" />
            <Input
              style="height: 50px"
              v-model="formItem.validateCode"
              placeholder="请输入动态密码"
            ></Input
            ><Button
              v-show="codeList"
              @click="getCode('formItem')"
              style="position: absolute; top: 0px; right: 0px; width: 100px; height: 45px"
              >获取验证码</Button
            >
            <Button
              v-show="!codeList"
              style="position: absolute; top: 0px; right: 0px; width: 100px; height: 45px"
              >{{ times }}秒</Button
            >
          </FormItem>
          <FormItem>
            <Button style="width: 100%; height: 40px" @click="next()" type="primary"
              >下一步</Button
            >
          </FormItem>
        </div>

        <div v-else-if="comlist == 1">
          <FormItem class="liItem" prop="inputs">
            <img style="width: 22px; height: 25px" src="@/assets/image/suo.png" />
            <Input
              height="50px"
              type="password"
              v-model="formItem.inputs"
              placeholder="请输入您的密码"
            >
            </Input>
          </FormItem>
          <FormItem class="liItem myPasswordInput" prop="pwd">
            <img style="width: 22px; height: 25px" src="@/assets/image/suo.png" />
            <Input
              height="50px"
              type="password"
              password
              v-model="formItem.pwd"
              placeholder="请再次输入您的密码"
            >
            </Input>
            <div class="passwor" @click="forget()">返回登录</div>
          </FormItem>
          <FormItem>
            <Button
              style="width: 100%; height: 40px"
              @click="nextlives('formItem')"
              type="primary"
              >确定</Button
            >
          </FormItem>
        </div>
        <VerifyCode
          ref="verifyCode"
          :show="show"
          :phone="formItem.mobile"
          @success="handleVerifySuccess"
          @close="handleVerifyClose" />
      </Form>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>
<script>
import {
  email,
  realName,
  select,
  upload,
  empty,
  phone,
  password,
  identity,
  verificationCode,
  pws,
  selectcity,
} from "@/core/charm/charm";
var vm;
import VerifyCode from "./verifyCode.vue";
export default {
  props: ["liveTop", "comlist"],
  name: "",
  data() {
    return {
      formItem: {
        inputs: "",
        mobile: "",
        validateCode: "",
        pwd: "",
      },
      ruleInfo: { 
          inputs: empty("你的密码"), 
          pwd: empty("你的密码"), 
          verifyStatus: [
            { validator: () => this.$refs.verifyRef.status, message: '请拖动滑块进行验证', trigger: 'change'},
          ], 
      },
      git_live: false,

      times: "", //验证码获取时间
      codeList: true,
      count: null,
      show: false,
    };
  },
  components: {
    VerifyCode,
  },
  created() {
    vm = this;
  },
  watch: {
    // liveTop(item) {
    //   this.liveTop = item;
    // },
    comlist(item) {
      this.comlist = item;
    },
    // comlist(item) {
    //   this.comlist = item;
    // },
  },
  mounted() {
    this.comlist = this.comlist;
    // this.comlist = this.liveTop;
    // console.log(this.comlist);
    // if (this.liveTop) {
    //   this.comlist = true;
    // } else {
    //   this.comlist = false;
    // }
  },
  methods: {
    next() {
      var phoneList = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      var texList = /^[0-9]{6}$/;
      if(this.formItem.mobile == ""){
          this.$Message.error("请输入手机号!");
          return;
      }else if(!phoneList.test(vm.formItem.mobile)){
        this.$Message.error("手机号码格式有误!");
        return;
      }
      if (texList.test(vm.formItem.validateCode)) {
        vm.comlist = 1;
      } else {
        this.$Message.error("验证码格式有误!");
      }
      clearInterval(this.count);
      this.times= 0;
    },
    forget() {
      this.liveTop = false;
      this.formItem = {
        inputs: "",
        mobile: "",
        validateCode: "",
        pwd: "",
      };
      this.codeList = true;
      vm.$emit("passwords", vm.liveTop);
    },
    nextlives(name) {
      if(this.formItem.inputs == ""){
        this.$Message.error("请输入密码!");
        return;
      }else if(this.formItem.pwd == ""){
        this.$Message.error("请再次输入密码!");
        return;
      }else if(this.formItem.inputs != this.formItem.pwd || this.formItem.pwd != this.formItem.inputs){
        this.$Message.error("您输入的密码不一致!");
        return;
      } 
      var data = {
        mobile: vm.formItem.mobile,
        validateCode: vm.formItem.validateCode,
        pwd: vm.formItem.pwd,
      };
      this.$apis.manage.foget(data).then((res) => {
        if(res.resultCode == 200){
          this.$Message.success("修改成功,请重新登录!");
          this.formItem = {
            inputs: "",
            mobile: "",
            validateCode: "",
            pwd: "",
          };
          this.codeList = true;
          this.liveTop = false;
          vm.$emit("passwords", vm.liveTop);
        }else{
          this.$Message.error(res.resultDesc);
        }
        
      });
    },
    async getCode(name) {
      var inputs = /^1[3456789]\d{9}$/;
      if(vm.formItem.mobile == ""){
        this.$Message.error("请输入手机号!"); 
        return
      }else if(!inputs.test(vm.formItem.mobile)) {
        this.$Message.error("手机号格式有误!");
        return
      }

      // 校验手机号是否注册
      const res = await this.$apis.manage.accountIsExist({
        account: vm.formItem.mobile,
      })
      if(res.data){
        return this.$Message.error("该手机号未被注册"); 
      }
      if (this.times) return
      this.show = true;
    },
    yanzheng() {
      var data = {
        phone: vm.formItem.mobile,
        adapter: "retrieve_pwd",
      };
      this.$apis.manage
        .regiteList(data)
        .then((res) => {
          if (res.messageType == "Success") {
            this.$Message.success("发送成功!");
            const TIME_COUNT = 60;
            this.times = TIME_COUNT;
            this.codeList = false;
            this.times = 60;
            this.count = setInterval(() => {
              this.times--;
              if (this.times <= 0) {
                this.codeList = true;
                clearInterval(this.count);
              }
            }, 1000);
          } else {
            this.$Message.error("发送失败!");
          }
        })
        .catch((err) => {});
    },

    cancel() {
      vm.liveTop = false;
      vm.$emit("passwords", vm.liveTop);
    },
    handleVerifySuccess() {
      this.show = false;
      this.yanzheng();
    },
    handleVerifyClose () {
      this.show = false;
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
.flex_left {
  display: flex;
  justify-content: space-between;
}

/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/deep/ .ivu-input {
  height: 45px;
  padding-left: 55px;
}
.zhuce {
  padding-top: 0px;
  padding-bottom: 30px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2150cb;
  line-height: 24px;
}
.liItem {
  position: relative;
}
.liItem img {
  display: block;
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 999999;
}
.top_input /deep/ .ivu-input {
  width: 240px;
}
/deep/.ivu-modal-footer {
  display: none;
}
.passwor {
  text-align: right;
  cursor: pointer;
}

.myPasswordInput /deep/ .ivu-icon {
  font-size: 22px;
  line-height: 42px;
}
</style>
